import OutsidePressHandlerRoot from "react-native-outside-press";
import { cloneElement, ComponentProps, useEffect, useRef } from "react";

type OutsideEventHandler = (event?: Event) => void;

const useOutsideEvents = <T extends HTMLElement>(
    ref: React.RefObject<T>,
    onOutside: OutsideEventHandler,
) => {
    useEffect(() => {
        const handleEvent = (e: Event) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                onOutside(e);
            }
        };

        document.addEventListener("scroll", handleEvent, { capture: true, once: true });
        document.addEventListener("blur", handleEvent, { capture: true, once: true });
    }, [ref, onOutside]);
};

type OutsidePressHandlerProps = ComponentProps<typeof OutsidePressHandlerRoot>;

export const OutsidePressHandler = ({ onOutsidePress, children }: OutsidePressHandlerProps) => {
    const menuRef = useRef<HTMLDivElement>(null);

    useOutsideEvents(menuRef, onOutsidePress);

    return cloneElement(children as React.ReactElement, { ref: menuRef });
};
